export default __webpack_public_path__ + "static/media/1057.08e5eb27.png";